export function fetchFreeSearchOutput(sv, localCount){
	if(localCount === dataholder.commandCount){
		renderSearchLoader();
		dataholder.userMayEnter = false;
		if( dataholder.freeTextSearchData === false )
		{
			fetchFreeTextSearchData(sv, localCount, 'renderSearchResult')
		}
		else
		{
			renderSearchResult(sv);
		}
	}
}

export function fetchFreeTextSearchData( sv, localCount, callback )
{
	dataholder.isLoadingFreeTextSearchData = true;
	$.ajax({
		url: dataholder.themeUrl + "/includes/freeTextSearch/freeTextSearch.php",
		type: 'POST',
		data: {
			searched: sv,
			lang: siteLang,
			siteUrl: siteUrl
		},
		success: function (data)
		{
			dataholder.isLoadingFreeTextSearchData = false;
			dataholder.freeTextSearchData = JSON.parse(data);
			console.log('data');
			if ( typeof localCount !== 'undefined' && typeof callback !== 'undefined' && localCount === dataholder.commandCount)
			{
				const fn = window[callback];
				if (typeof fn === 'function')
				{
					fn(sv);
				}
			}
		}
	});
}

export function renderSearchLoader()
{
	$('#freeSearchForm .submitBtn').html('<div class="freeTextSearchIcon"><div class="icon"></div></div>')
}

function renderSearchResult(sv)
{
	const searchResult = performFreeTextSearch(sv);
	let totalCount = 0;
	if( searchResult !== false )
	{
		const searchKeys = Object.keys(searchResult);
		for (let i = 0; i < searchKeys.length; i++)
		{
			totalCount += searchResult[searchKeys[i]].length;
		}
	}
	
	var houseName = (totalCount === 1) ? wpTranslatedStrings.terms.house : wpTranslatedStrings.terms.houses;
	$('#freeSearchForm .submitBtn').html(totalCount + ' ' + houseName);
	if (searchResult !== false && totalCount > 0 )
	{
		dataholder.userMayEnter = true;
		var output = buildSearchOutput(searchResult, sv);
		$("#freeSearchOutputWrapper").html(output).addClass("active");
		$("body").addClass("freeTextResultShown");
	}
	else
	{
		clearInterval(dataholder.enterInterval);
		const text = (siteLang === 'de') ? "<p>Ihre suche ergab keine ergebnisse...</p>" : "<p>Din søgning gav desværre ingen resultater...</p>" ;
		$("#freeSearchOutputWrapper").html(text).addClass("active");
		$("body").addClass("freeTextResultShown");
	}
}



function buildSearchOutput( result, sv )
{
	var string = '';
	var totalCount = 0;
	var resultKeys = Object.keys(result);
	var added = 0;
	
	for (var i = 0; i < resultKeys.length; i++)
	{
		totalCount += result[resultKeys[i]].length;
	}
	
	for( var i = 0; i < resultKeys.length; i++ )
	{
		for( var x = 0; x < result[resultKeys[i]].length; x++ )
		{
			if( added === 5 )
			{
				break;
			}
			var post = result[resultKeys[i]][x];
			var selectedClassNext = '';
			var selectedClassPrev = '';
			if( added === 0 )
			{
				selectedClassNext = 'first';
			}
			if (added === totalCount && totalCount !== 5)
			{
				selectedClassPrev = 'last';
			}
			added++;
			var finalUrl = post.url + '?freeTextQuery=true&query='+encodeURIComponent(sv)+'&label='+encodeURIComponent(post.address+' ('+post.catNum+')');
			string += '<li class="searchHouseItem '+ selectedClassNext + ' ' + selectedClassPrev+ '">';
				string += '<a href="'+finalUrl+'">';
					string += '<div class="left">';
						string += '<img class="img-responsive" src="'+post.img+'"/>';
					string += '</div>';
					string += '<div class="right"><strong>'+ post.address +'</strong> ('+ post.catNum+')</div>';
					string += '<div class="clearfix"></div>';
				string += '</a>';
			string += '</li>';
			
		}
	}
	
	if(totalCount !== 0)
	{
		
		var siteurl = "";
		var searchText = '';
		if (siteLang === "de")
		{
			siteurl = siteSearchPage + "?result/#/page=/1";
			searchText = 'Alle Ergebnisse für "'+sv+'"';
		}
		else if (siteLang === "dk")
		{
			siteurl = siteSearchPage + "?result/#/page=/1";
			searchText = 'Se alle resultater for "'+sv+'"';
		}
		
		string += '<li class="showMoreSearchItems last">'
			string += '<a href="' + siteurl + '">' + searchText + '</a>';
		string += '</li>';
	}
	
	return string;
}

function performFreeTextSearch(sv)
{
	var data = dataholder.freeTextSearchData;
	if( typeof data === 'object' )
	{
		var result = {0: [], 1: [], 2: [], 3: [], 4: []};
		sv = sv.toLocaleLowerCase();
		for (var i = 0; i < data.length; i++)
		{
			if (data[i].catNum.toLocaleLowerCase().indexOf(sv) !== -1)
			{
				result[0].push(data[i]);
			}
			else if (data[i].area.toLocaleLowerCase().indexOf(sv) !== -1)
			{
				result[1].push(data[i]);
			}
			else if (data[i].address.toLocaleLowerCase().indexOf(sv) !== -1)
			{
				result[2].push(data[i]);
			}
			else if (data[i].facilities.toLocaleLowerCase().indexOf(sv) !== -1)
			{
				result[3].push(data[i]);
			}
			else if (data[i].post_title.toLocaleLowerCase().indexOf(sv) !== -1 || (typeof data[i].post_content !== 'undefined' && data[i].post_content.toLocaleLowerCase().indexOf(sv) !== -1))
			{
				result[4].push(data[i]);
			}
		}
		return result;
	}
	return false;
}


export function hideFreeSearchOutputWrapper(){
	$("body").removeClass("freeTextResultShown");
	$("#freeSearchOutputWrapper").removeClass("active");
}

export function showFreeSearchOutputWrapper(){
	$("body").addClass("freeTextResultShown");
	$("#freeSearchOutputWrapper").addClass("active");
}
